module.exports = __webpack_public_path__ + "img/仿真恐龙公仔-2.20f2991f.jpg";